import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Creating a new offer',
  subtitle: 'How does the customer get a free item?',
  validation: {
    required: 'Please select an offer type',
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Total order value',
      description: 'E.g. 10% off your order when you spend 20 {{currency}}',
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Selected items',
      description: 'E.g. 10% off 12-inch pizzas.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Selected items',
      description: 'E.g. 1 {{currency}} off 12-inch pizzas.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Total order value',
      description: 'E.g. 1 {{currency}} off your order when you spend 20 {{currency}}',
    },
    [OFFER_KIND.BOGO]: {
      name: 'Buy 1 get 1 free',
      description: 'E.g. Buy 1 pizza get another pizza free. The cheapest pizza is discounted.',
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: 'Buy 1 get 1 half price',
      description: 'E.g. Buy 1 pizza get another price half price, the cheapest pizza is discounted.',
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'By buying another item',
      description: 'E.g. Get a free drink when you order a meal.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'By spending fixed {{currency}} amount',
      description: 'E.g. Get a free dessert when you spend 20 {{currency}}.',
    },
  },
};
